<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <string-form-field
      :label="$t('creditAssignmentFile.fields.title')"
      required
      :value="value.title"
      :disabled="disabled"
      :error="findError('title')"
      @input="propertyChange('title', $event)"
    />

    <number-form-field
      :label="$t('creditAssignmentFile.fields.requestedAmount')"
      required
      prepend="€"
      :precision="2"
      :value="value.requestedAmount"
      :disabled="disabled"
      :error="findError('requestedAmount')"
      @input="propertyChange('requestedAmount', $event)"
    />

    <number-form-field
      :label="$t('creditAssignmentFile.fields.providedAmount')"
      required
      prepend="€"
      :precision="2"
      :value="value.providedAmount"
      :disabled="disabled"
      :error="findError('providedAmount')"
      @input="propertyChange('providedAmount', $event)"
    />

    <string-form-field
      :label="$t('creditAssignmentFile.fields.description')"
      required
      multiline
      :value="value.description"
      :disabled="disabled"
      :error="findError('description')"
      @input="propertyChange('description', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
